import { useState } from "react";
import { X, Calculator } from "@phosphor-icons/react";

const fmt = (n) => new Intl.NumberFormat("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

export default function ChangeCalculator({ open, onClose, total = 0, onApply }) {
  const [paid, setPaid] = useState("");

  if (!open) return null;

  const paidNum = parseFloat(paid) || 0;
  const change = paidNum - total;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-testid="change-calc-modal">
      <div className="glass-card rounded-xl w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-6">
          <h3 className="font-heading text-lg font-semibold flex items-center gap-2">
            <Calculator size={22} className="text-turquoise" />
            Calculadora de vuelto
          </h3>
          <button onClick={onClose} className="text-zinc-400 hover:text-white" data-testid="change-calc-close">
            <X size={20} />
          </button>
        </div>

        <div className="space-y-4">
          <div className="bg-black/40 rounded-md p-4 border border-white/5">
            <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-mono mb-1">A pagar</p>
            <p className="text-3xl font-mono font-medium text-white tabular-nums">$ {fmt(total)}</p>
          </div>

          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-400 font-mono">Recibido</label>
            <input
              type="number"
              value={paid}
              onChange={(e) => setPaid(e.target.value)}
              autoFocus
              data-testid="change-calc-paid-input"
              placeholder="0.00"
              className="mt-2 w-full bg-black/40 border border-white/10 rounded-md px-4 py-3 text-2xl font-mono text-white focus:outline-none focus:border-turquoise transition"
            />
          </div>

          <div className="grid grid-cols-4 gap-2">
            {[100, 500, 1000, 2000, 5000, 10000, 20000, 50000].map((q) => (
              <button
                key={q}
                onClick={() => setPaid(String((parseFloat(paid) || 0) + q))}
                className="bg-white/5 hover:bg-white/10 text-xs font-mono py-2 rounded-md border border-white/5 transition"
              >
                +{q}
              </button>
            ))}
          </div>

          <div className={`rounded-md p-4 border ${change < 0 ? "bg-red-500/10 border-red-500/30" : "bg-turquoise/10 border-turquoise/30"}`}>
            <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-400 font-mono mb-1">Vuelto</p>
            <p
              data-testid="change-calc-result"
              className={`text-4xl font-mono font-medium tabular-nums ${change < 0 ? "text-red-400" : "text-turquoise"}`}
            >
              $ {fmt(Math.abs(change))}
              {change < 0 && <span className="text-sm ml-2">(faltan)</span>}
            </p>
          </div>

          <div className="flex gap-3 pt-2">
            <button
              onClick={() => { setPaid(""); }}
              className="flex-1 bg-white/5 border border-white/10 py-2.5 rounded-md text-sm hover:bg-white/10"
            >
              Limpiar
            </button>
            {onApply && (
              <button
                disabled={change < 0}
                onClick={() => { onApply(paidNum); onClose(); }}
                data-testid="change-calc-apply"
                className="flex-1 bg-brand-gradient text-black font-semibold py-2.5 rounded-md disabled:opacity-40"
              >
                Aplicar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
